import axios from 'axios';
import {OpenAPI} from '@/openapi';
import {useApiUrl} from '@/composables/useApiUrl';
import {getOpenApiSsrHeaders} from '#shared/utils/ssrRequestContext';

export default defineNuxtPlugin(() => {
	OpenAPI.BASE = useApiUrl();
	OpenAPI.WITH_CREDENTIALS = true;

	if (import.meta.server) {
		OpenAPI.HEADERS = () => Promise.resolve(getOpenApiSsrHeaders());
	}

	// Client-only: shared axios on SSR has no per-request context for 401 handling.
	if (import.meta.client) {
		const {handleUnauthorized} = useUnauthorizedPolicy();

		axios.interceptors.response.use(
			(response) => response,
			(error) => {
				if (error?.response?.status === 401) {
					handleUnauthorized().catch(() => {});
				}

				return Promise.reject(error);
			},
		);
	}
});
